import axios from "axios";
import { BASE_API, APPLICATION } from "../../constants";
import { formatUsersCart } from "../cart/FormatUsersCart";
import { toast } from "react-toastify";

export const fetchCartData = async ({ appContext, setAppContext }) => {
  try {
    const response = await axios.get(`${BASE_API}api/Cart/GetMyCart`, {
      headers: {
        Authorization: `Bearer ${appContext.userInfo.token}`,
        Application: APPLICATION,
      },
    });

    if (!response.data.Cart || response.data.Cart.length < 1) {
      return;
    }

    const results = formatUsersCart(response);
    let newPrice = results.loaded_cartItems.reduce(
      (total, item) => total + item.ItemTotalPrice,
      0
    );

    try {
      await axios.put(
        `${BASE_API}api/Cart/UpdateCartPrice/${newPrice}`,
        { newPrice },
        {
          headers: {
            Authorization: `Bearer ${appContext.userInfo.token}`,
            Application: APPLICATION,
          },
        }
      );
    } catch (updateError) {
      console.error("Failed to update cart price:", updateError);
    }

    const newAppContext = {
      userInfo: appContext.userInfo,
      cart: results.loaded_cart,
      cartItems: results.loaded_cartItems,
    };

    setAppContext(newAppContext);
    localStorage.setItem("appContext", JSON.stringify(newAppContext));
  } catch (error) {
    if (error.response?.status === 401) {
      const newAppContext = {
        userInfo: null,
        cart: null,
        cartItems: null,
      };
      setAppContext(newAppContext);
      localStorage.setItem("appContext", JSON.stringify(newAppContext));
      toast.error("Your session has expired. Please login again.");
    } else {
      console.error("Failed to fetch cart data:", error);
    }
  }
};
